const runtimeSystemVariables = (window as any)?._env_;

const config = {
    tachoAPI: {
        url: runtimeSystemVariables?.API_URL || 'https://api.panel.tsr.com.pl',
        //url: 'https://localhost:5001', // Url for test if you will run api locally from Visual Studio
    },
    language: runtimeSystemVariables?.LOCALE || 'pl-PL',
    downloadFileTimeOut: runtimeSystemVariables?.DOWNLOAD_FILE_TIMEOUT
        ? parseInt(runtimeSystemVariables.DOWNLOAD_FILE_TIMEOUT, 10)
        : 120000,
    clientId: '1f7f784f-06fd-4595-969d-0ea0b02b2cfb',
    redirectUri: 'https://panel.tsr.com.pl',
    //redirectUri: 'http://localhost:3000', // for development
    tenantId: 'df34f2d7-1282-41a1-a45f-33c9e86161e5',
    b2cScopes: ['https://tsrbo.onmicrosoft.com/07859953-4fd0-4eeb-be8f-302521084762/Read.Api'],
};
console.log('App configuration', config);
export default Object.freeze(config);
